<section class="login-shell">
  <div class="card">
    <h1>AfriFood Admin</h1>
    <p>Connexion réservée aux administrateurs et managers.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <label>
        <span>Email</span>
        <input type="email" formControlName="email" placeholder="admin@afrifood.fr" />
      </label>

      <label>
        <span>Mot de passe</span>
        <input type="password" formControlName="password" placeholder="••••••••" />
      </label>

      <button type="button" class="secondary-link" [disabled]="loading" (click)="requestPasswordReset()">
        Recevoir un lien de réinitialisation
      </button>

      <button type="submit" [disabled]="loading">
        <ng-container *ngIf="loading; else loginLabel">
          <span class="spinner sm" aria-hidden="true"></span>
          <span>Connexion...</span>
        </ng-container>
        <ng-template #loginLabel>Se connecter</ng-template>
      </button>

      <p class="info" *ngIf="infoMessage">{{ infoMessage }}</p>
      <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </form>

    <div class="legal-links">
      <a [href]="publicWebsiteBaseUrl + '/privacy-policy'">Politique de confidentialite</a>
      <a [href]="publicWebsiteBaseUrl + '/data-deletion-request'">Suppression des donnees</a>
    </div>
  </div>
</section>
